import {styled} from '@mui/material';

export const filteredStyled = (element: any, toBeRemoved: Array<string>) =>
  styled(element, {
    shouldForwardProp: (prop: string) => !toBeRemoved.includes(prop),
  });
